// extracted by mini-css-extract-plugin
export default {"container":"error-fallback_container__i49q6","error-id":"error-fallback_error-id__1VLVd"};